module.exports = __webpack_public_path__ + "img/R06_S1.84bb7a8f.svg";